import script from "./CardBoxWaiver.vue?vue&type=script&setup=true&lang=js"
export * from "./CardBoxWaiver.vue?vue&type=script&setup=true&lang=js"

import "./CardBoxWaiver.vue?vue&type=style&index=0&id=4c5fc500&scoped=true&lang=css"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c5fc500"]])

export default __exports__